import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Swiper from "swiper";
import {Navigation} from "swiper/modules";
gsap.registerPlugin(ScrollTrigger, SplitText);
const isMobileFirstLoad = window.innerWidth < 768;

if (!isMobileFirstLoad) {
    const tlPlugAndSave = gsap.timeline({
        scrollTrigger: {
            trigger: '.mksun-plug-and-save'
        }
    });

    const titlePlugAndSave = new SplitText('.mksun-plug-and-save .timeline-text-reveal', {
        type: 'words'
    });

    const linesPlugAndSave = new SplitText('.mksun-plug-and-save .timeline-text-reveal--lines', {
        type: 'lines',
        linesClass: 'line'
    });

    tlPlugAndSave.from(
        titlePlugAndSave.words,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlPlugAndSave.from(
        linesPlugAndSave.lines,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlPlugAndSave.from(
        '.mksun-plug-and-save__text__controls__control',
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );
}

if (!isMobileFirstLoad) {
    const tlSlidesPlugAndSave = gsap.timeline({
        scrollTrigger: {
            trigger: '.mksun-plug-and-save__slider',
            start: 'top center'
        }
    });

    const slidesPlugAndSave = document.querySelectorAll(
        '.mksun-plug-and-save__slider .swiper-slide, .mksun-plug-and-save--teaser .mksun-plug-and-save__slider__ctn__slide'
    );

    tlSlidesPlugAndSave.from(
        slidesPlugAndSave,
        {
            y: 32,
            opacity: 0,
            stagger: 0.2
        },
        '<'
    );
}

new Swiper('.mksun-plug-and-save:not(.mksun-plug-and-save--teaser) .mksun-plug-and-save__slider', {
    modules: [Navigation],
    navigation: {
        nextEl: '.mksun-plug-and-save__text__controls--next',
        prevEl: '.mksun-plug-and-save__text__controls--prev',
    },
    slidesPerView: 'auto',
    grabCursor: true,
    spaceBetween: 20
});